/**
 * Cliente de telemetría de store-ui — usa el paquete compartido @lala/telemetry-sdk.
 *
 * El core, la instrumentación y los bindings React viven en el paquete; aquí solo
 * se crea el singleton web con la config de store y se expone de forma lazy/SSR-safe.
 */
import { createWebTelemetry, getWebTelemetry, type TelemetryClient } from '@lala/telemetry-sdk/web';

const config = {
  gatewayUrl: process.env.NEXT_PUBLIC_GATEWAY_URL || '',
  writeKey: process.env.NEXT_PUBLIC_TELEMETRY_WRITE_KEY || '',
  debug: process.env.NEXT_PUBLIC_TELEMETRY_DEBUG === 'true',
};

/**
 * Devuelve el cliente de telemetría (singleton). `null` en SSR.
 * La primera llamada en el navegador lo crea (init + auto-instrumentación).
 */
export function getTelemetry(): TelemetryClient | null {
  if (typeof window === 'undefined') return null;
  return getWebTelemetry() ?? createWebTelemetry(config);
}
